// import Button from "@gigandtake/button";
import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import Button from "../../../../../design/button";

interface ActionButtonsProps {
  markAttendanceStatus: "pending" | "success" | "error";
  markAttendanceError: string;
  onClose: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  markAttendanceStatus,
  markAttendanceError,
  onClose,
}) => {
  const { t } = useTranslation();
  return (
    <Box>
      {markAttendanceStatus === "error" ? (
        <Typography variant="body2" color="error">
          {markAttendanceError}
        </Typography>
      ) : null}
      <Button onClick={onClose}>
        {t("common_close")}
      </Button>
    </Box>
  );
};

export default ActionButtons;
